import { JSX } from "react";
import SigninWithPassword from "./signinWhitPassword";

const styles = {
    container: 'my-6 flex items-center justify-center',
    divider: 'block h-px w-full bg-stroke',
    label: 'block w-full min-w-fit bg-white px-3 text-center font-medium',
};

const Signin = (): JSX.Element => {

    return (
        <>
            <div className={styles.container}>
                <span className={styles.divider}></span>
                <div className={styles.label}>
                    Inicia sesión
                </div>
                <span className={styles.divider}></span>
            </div>
            <div>
                <SigninWithPassword/>
            </div>

        </>
    );
}


export default Signin;